/* eslint-disable import/order */
/* eslint-disable import/no-unresolved */
import { Icon } from "@iconify/react";
import { useLocation } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import OrderModal from "../components/OrderModal";
import closeCircleFill from "@iconify/icons-eva/close-circle-fill";
import arrowCircleLeftFill from "@iconify/icons-eva/arrow-circle-left-fill";
import plusFill from "@iconify/icons-eva/plus-fill";
import inboxOutline from "@iconify/icons-eva/inbox-outline";
import {
  Card,
  Stack,
  Button,
  IconButton,
  Typography,
  CardHeader,
  CardContent,
} from "@mui/material";

import actionService from "../services/actionService";

import {
  Timeline,
  TimelineItem,
  TimelineDot,
  TimelineContent,
  TimelineConnector,
  TimelineSeparator,
  TimelineOppositeContent,
} from "@mui/lab";
import orderService from "../services/orderService";

function printTag(base64: string) {
  const winparams =
    "dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,resizable,screenX=50,screenY=50,width=850,height=1050";
  const html = `
  <embed
    width=100%
    height=100%
    type="application/pdf"
    src="data:application/pdf;base64,${base64}"
  ></embed>`;
  const printWindow = window.open("", "PDF", winparams);
  if (printWindow) {
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.addEventListener("load", () => {
      setTimeout(() => {
        printWindow.print();
      }, 2000);
    });
  }
}

export default function ActionCard(props: any) {
  const errorAlertHandler = props.setError as React.Dispatch<
    React.SetStateAction<boolean | null>
  >;

  const messageAlertHandler = props.errorAlertHandler as React.Dispatch<
    React.SetStateAction<string | null>
  >;

  const { state }: any = useLocation();
  const [ip, setIp]: any = useState();
  const [data, setData]: any = useState();
  const [query, setQuery]: any = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [actionsDisabled, setActionsDisabled] = useState(false);
  const [warrantyAvailable, setWarrantyAvailable] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    setIsAdmin(user.role === "Administrador");
  }, []);

  useEffect(() => {
    getSelects();
    const res = props?.selectData?.ip;
    if (Array.isArray(res)) setIp([res[0].number_Ip, res[1].number_Ip]);
    else setIp(res);
  }, []);

  useEffect(() => {
    if (state) reloadActions();
    if (state.actions && state.actions.length >= query.length) {
      setQuery(state.actions);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    getSelects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  useEffect(() => {
    if (!modalOpen) {
      reloadActions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);

  useEffect(() => {
    if (Array.isArray(query)) {
      const user = JSON.parse(localStorage.getItem("user") || "{}");

      setActionsDisabled(
        user.role !== "Administrador" && query.some(
          (obj: any) =>
            !obj?.disabled_OS && (
              obj?.type === "BAIXA" ||
              obj?.type === "CANCELADA" ||
              obj?.type === "REPROVADA NO RECEBIMENTO"
            )
        )
      );

      setWarrantyAvailable(query.some((obj: any) => obj?.type === "BAIXA" && !obj?.disabled_OS));
    }
  }, [query]);

  const reloadActions = async () => {
    orderService.getActions(props.code_Order).then((res) => {
      setQuery(res.data);
    });
  };

  const tagPrinter = useCallback(
    (tagCode: string | number | undefined) => {
      orderService
        .getTagGuarantee(tagCode ?? "")
        .then((r) => {
          const { base64 } = r.data;
          printTag(base64);
        })
        .catch((err: any) => {
          if (messageAlertHandler) {
            messageAlertHandler(null as any);
            setTimeout(() => {
              messageAlertHandler(
                err?.response?.data?.message ||
                "Não foi possível gerar a etiqueta"
              );
            }, 50);
          } else {
            errorAlertHandler(true);
          }
        });
    },
    [errorAlertHandler, messageAlertHandler]
  );

  const handleToggleDisable = async (id_OS: number) => {
    try {
      const res: any = await orderService.toggleActionDisable(id_OS);
      if (res.status === 200) {
        reloadActions();
      }
    } catch (error) {
      console.error("Error toggling action disable", error);
    }
  };

  const getSelects = async () => {
    setData({
      rework: props?.selectData.rework,
      message: props?.selectData.message,
    });
  };

  return (
    <>
      <OrderModal
        data={data}
        open={modalOpen}
        code_Order={props.code_Order}
        handler={() => setModalOpen(false)}
        setError={(value: boolean) => props.setError(value)}
        setSuccess={(value: boolean) => {
          props.setSuccess(value);
        }}
        errorAlertHandler={messageAlertHandler}
      />

      <Card sx={{ marginTop: "32px" }}>
        <CardHeader
          sx={{
            background: "#004A78",
            color: "#fff",
            paddingLeft: "30px",
            paddingBottom: "10px",
            paddingTop: "10px",
          }}
          title={
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ pr: 2 }}>
              <Typography variant="h6" color="inherit">Ações</Typography>
              {isAdmin && <Typography variant="subtitle2" sx={{
                bgcolor: (state?.idBilling_Order || state?.billing_Order) ? 'success.main' : 'warning.main',
                px: 1.5,
                py: 0.5,
                borderRadius: 1,
                fontWeight: 700
              }}>
                {state?.idBilling_Order ? `Fechamento: #${state.idBilling_Order}` :
                  state?.billing_Order ? 'Status: Fechado' : 'Status: Em Aberto'}
              </Typography>}

            </Stack>
          }
        />
        <CardContent>
          <Stack
            direction={["column", "row"]}
            justifyContent="flex-start"
            marginBottom={query.length && !!query[0]?.date ? 2 : -2}
          >
            <Button
              sx={{
                height: "48px",
                lineHeight: "18px",
                borderRadius: "40px",
                background: "#004A78",
                "&:hover": {
                  bgcolor: "#226C9A",
                },
              }}
              disabled={(query.length && !query[0]?.date) || actionsDisabled}
              color="secondary"
              variant="contained"
              onClick={() => setModalOpen(true)}
              startIcon={<Icon icon={plusFill} />}
            >
              Nova Ação
            </Button>
            <Button
              sx={{
                height: "48px",
                paddingX: "32px",
                lineHeight: "18px",
                marginTop: ["12px", 0],
                marginLeft: [0, "18px"],
                borderRadius: "40px",
                background: "#004A78",
                "&:hover": {
                  bgcolor: "#226C9A",
                },
              }}
              color="secondary"
              variant="contained"
              disabled={!warrantyAvailable}
              onClick={() => tagPrinter(state?.code_Order)}
            >
              Gerar Garantia
            </Button>
          </Stack>
          {query.length && !!query[0]?.date ? (
            <Timeline sx={{ ml: ["-35%", "-80%"] }}>
              {query.filter((item: any) => isAdmin || !item.disabled_OS).map((item: any, index: number) => {
                let dateTime = item.date.split(" ");
                const isDisabled = item.disabled_OS;

                return (
                  <TimelineItem key={index} sx={{ opacity: isDisabled ? 0.5 : 1 }}>
                    <TimelineOppositeContent>
                      <Typography color="textSecondary" sx={{ color: isDisabled ? "grey.500" : "text.secondary" }}>
                        {dateTime[1].split(":").slice(0, -1).join(":")}
                      </Typography>
                      <Typography lineHeight={1} color="textSecondary" sx={{ color: isDisabled ? "grey.500" : "text.secondary" }}>
                        {query.length && dateTime[0].replace("/20", "/")}
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          width: "28px",
                          height: "28px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: isDisabled ? "grey.400" : "secondary.main"
                        }}
                        color="secondary"
                      >
                        <Typography>{index + 1}</Typography>
                      </TimelineDot>
                      {index + 1 !== query.length && <TimelineConnector />}
                    </TimelineSeparator>
                    <TimelineContent sx={{ pt: 0.2 }}>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography variant="h5" sx={{ color: isDisabled ? "grey.500" : "text.primary", textDecoration: isDisabled ? "line-through" : "none" }}>
                          {item.type}
                        </Typography>
                        {isAdmin && item.id_OS && !(state?.idBilling_Order || state?.billing_Order) && (
                          <IconButton
                            size="small"
                            onClick={() => handleToggleDisable(item.id_OS)}
                            disabled={!isAdmin && isDisabled}
                            sx={{
                              color: isDisabled ? "success.main" : "error.main",
                              "& .iconify": { width: 24, height: 24 }
                            }}
                            title={isDisabled ? "Reativar ação" : "Desativar ação"}
                          >
                            <Icon icon={isDisabled ? arrowCircleLeftFill : closeCircleFill} />
                          </IconButton>
                        )}
                      </Stack>
                      <Typography variant="body1" lineHeight="12px" sx={{ color: isDisabled ? "grey.500" : "text.secondary" }}>
                        {item.description ||
                          (item.nameContinueProcess
                            ? `Autorizado por: ${item.nameContinueProcess}`
                            : "")}{" "}
                      </Typography>
                      {item.observation && (
                        <Typography variant="body2" lineHeight="12px" sx={{ color: isDisabled ? "grey.500" : "text.secondary" }}>
                          Observação: {item.observation}
                        </Typography>
                      )}
                    </TimelineContent>
                  </TimelineItem>
                );
              })}
            </Timeline>
          ) : (
            <Stack
              paddingY="12px"
              width="100%"
              justifyContent="center"
              alignItems="center"
            >
              <Icon icon={inboxOutline} width="56px" color="#909090" />
              <Typography
                mt={1}
                variant="body1"
                noWrap
                sx={{ color: "#909090" }}
              >
                Nada registrado...
              </Typography>
            </Stack>
          )}
        </CardContent>
      </Card>
    </>
  );
}
